import { render, staticRenderFns } from "./MyPersonalExperiencePenelopeLumanog.vue?vue&type=template&id=48684336&scoped=true"
import script from "./MyPersonalExperiencePenelopeLumanog.vue?vue&type=script&lang=js"
export * from "./MyPersonalExperiencePenelopeLumanog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48684336",
  null
  
)

export default component.exports